import React from 'react';
import './HomePage.css'; 
import surfjournalcaptures from '../images/surfjournalcaptures.png';
import sessionsview from '../images/sessionsview.png';
import logsessionview from '../images/logsessionview.png';
import calendarview from '../images/calendarview.png';
import mapview from '../images/mapview.png';
import statsview from '../images/statsview.png';
import explainerposter from '../images/explainerposter.jpeg';
import { Link } from 'react-router-dom';
import ReactPlayer from 'react-player';
import Subscribe from '../Components/Subscribe';
import { Collapse } from 'antd';

const { Panel } = Collapse;




const HomePage = () => {
 
return (
    <div className="homepage">
      
      <HeroSection />
      
      <FullVideoSection />
      <CoreBenefits />
      <FAQ />
      <CallToAction />
    </div>
  );
};

const Header = () => (
  <header className="header">
    <h3>Beta Version</h3>
    <p>Thank you for your feedback</p>
  </header>
);

const HeroSection = () => (
  <section className="hero-section">
    <img src={surfjournalcaptures} alt="Digital Surf Journal" className="hero-image" />
    <div className="hero-text-content">
      <h1>Surf Journal</h1>
      <div className="hero-section-description">
        <h3>Session tracking & forecasting</h3>
        <p>Track your surf sessions with photos, notes, weather data, and ratings.</p>
      </div>
      <div className="hero-section-button">
      <Link to="https://apps.apple.com/us/app/surf-journal-app/id6504604479">
          <button className="secondary-btn">iOS</button>
        </Link>
        <Link to="/androidapp">
          <button className="secondary-btn">Android</button>
        </Link>
      </div>
    </div>
  </section>
);



const FullVideoSection = () => (
  <section className="full-video-section">
    <div className="full-video-container">
      <video
        controls
        playsInline
        className="full-iphone-video"
        poster={explainerposter}
      >
        <source src="/videos/explainer.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="full-video-explainer-text">
        <h2>How it works</h2>
        <p>
          Log a session<br/>
          Automaticly view conditions<br/>
          Track Stats, Maps, and More...
        </p>
      </div>
    </div>
  </section>
);

const CoreBenefits = () => (
  <section className="core-benefits">
    <div className="benefits">
      <div className="benefit benefit-left">
        <img src={logsessionview} alt="Surf Journal Log New Session" />
        <div className="text">
            <h2>Log A New Session</h2>
            <p>Record your session in less than a minute.</p>
        </div>
      </div>
      <div className="benefit benefit-right">
        <img src={sessionsview} alt="Surf Journal - Session Details Entry" />
        <div className="text">
            <h2>View Session Details</h2>
            <p>Images, notes, conditions, and more.</p>
        </div>
      </div>
      <div className="benefit benefit-left">
        <img src={calendarview} alt="Surf Journal Calendar View" />
        <div className="text">
            <h2>Session Calendar</h2>
            <p>Surf session by date and quality.</p>
        </div>
      </div>
      <div className="benefit benefit-right">
        <img src={mapview} alt="Surf Journal Map View" />
        <div className="text">
            <h2>My Breaks Map</h2>
            <p>Your surf spots mapped.</p>
        </div>
      </div>
      <div className="benefit benefit-left">
        <img src={statsview} alt="Surf Journal Stats View" />
        <div className="text">
            <h2>My Stats</h2>
            <p>Session time, quality, and trends at a glance.</p>
        </div>
      </div>
    </div>
  </section>
);

const FAQ = () => (
  <section className="faq-section">
    <h2>More questions...</h2>
    <Collapse accordion>
      {faqData.map((faq, index) => (
        <Panel header={faq.question} key={index}>
          <p>
            {faq.answer}
            {index === 2 && (
              <Link to="/androidapp"> Android App Testing</Link>
            )}
          </p>
        </Panel>
      ))}
    </Collapse>
  </section>
);

const CallToAction = () => (
  <section className="call-to-action">
    <h3>Want Updates?</h3>
    <p>Get notified when new features are launched.</p>
    <Subscribe />
  </section>
);



const faqData = [
  {
    question: 'How much does it cost?',
    answer: 'It\'s free. Future versions with advanced functionality may require a subscription, but all early adopters who provide feedback will get Surf Journal free for life. If you\'d like to join our test group please download the app and submit a question on the Settings page to let us know you\'d like to join the test group.'
  },
  {
    question: 'How do I provide my feedback?',
    answer: 'Navigate to the Settings page within the app.'
  },
  {
    question: 'When will Surf Journal be ready for Android?',
    answer: 'The Android test version is currently in beta. If you\'d like to get early access please register here:'
  },
];







export default HomePage;
